module.exports = __webpack_public_path__ + "static/img/inter-cirle-two-small.c168c407.png";